export interface PlaylistTrack {
  artist: string;
  cover: string;
  title: string;
}

const playlistTracks: Record<string, PlaylistTrack> = {
  "spotify:track:68HocO7fx9z0MgDU0ZPHro": {
    title: "Every Summertime",
    artist: "NIKI",
    cover: "https://i.scdn.co/image/ab67616d00001e02e81fd3b9a7230db447f38182",
  },
  "spotify:track:7lDFugi7xkhzH9cP4ITScn": {
    title: "Supernova",
    artist: "WIM",
    cover: "https://i.scdn.co/image/ab67616d00001e0270e1a429b3fc3f79fedecb4c",
  },
  "spotify:track:1gH1h30wkQdd9zhY3j7a8T": {
    title: "THE SHADE",
    artist: "Rex Orange County",
    cover: "https://i.scdn.co/image/ab67616d00001e02761dc49441e6d2a991d46dc7",
  },
  "spotify:track:48CiA3IjkNZiyl6S6UbPCy": {
    title: "Come Inside Of My Heart",
    artist: "IV OF SPADES",
    cover: "https://i.scdn.co/image/ab67616d00001e02f66c8c68a9710d44745c7680",
  },
  "spotify:track:4OBZT9EnhYIV17t4pGw7ig": {
    title: "Best Part (feat. H.E.R.)",
    artist: "Daniel Caesar, H.E.R.",
    cover: "https://i.scdn.co/image/ab67616d00001e02092701757191b300b7b210e8",
  },
  "spotify:track:2rd4FH1cSaWGc0ZiUaMbX9": {
    title: "Lover Boy",
    artist: "Phum Viphurit",
    cover: "https://i.scdn.co/image/ab67616d00001e02ebefdcb9f6e825e8582bbac4",
  },
  "spotify:track:4Szq4dulKN9bOvLRW6uMdZ": {
    title: "Carry Me Away",
    artist: "John Mayer",
    cover: "https://i.scdn.co/image/ab67616d00001e02779063301154e835a91a35e0",
  },
  "spotify:track:0tgBtQ0ISnMQOKorrN9HLX": {
    title: "Last Train Home",
    artist: "John Mayer",
    cover: "https://i.scdn.co/image/ab67616d00001e02779063301154e835a91a35e0",
  },
  "spotify:track:7G8FZsEfxn8NSylWQfBywp": {
    title: "Still The One",
    artist: "Jesse Barrera",
    cover: "https://i.scdn.co/image/ab67616d00001e02ac333d7671291ccb2fe0e4a6",
  },
  "spotify:track:5lE2EFXt4muvLFMGQg4hZN": {
    title: "Hypotheticals",
    artist: "Lake Street Dive",
    cover: "https://i.scdn.co/image/ab67616d00001e020c044e52637b2a8362e20659",
  },
  "spotify:track:4ercRiJZl8kBm8vfPaNjrl": {
    title: "On Melancholy Hill",
    artist: "Gorillaz",
    cover: "https://i.scdn.co/image/ab67616d00001e024960e8b13691e5570337d4d8",
  },
  "spotify:track:3TgMcrV32NUKjEG2ujn9eh": {
    title: "It's Not Living (If It's Not With You)",
    artist: "The 1975",
    cover: "https://i.scdn.co/image/ab67616d00001e026c582022e90b11f0da287a9a",
  },
  "spotify:track:4c6vZqYHFur11FbWATIJ9P": {
    title: "There She Goes",
    artist: "The La's",
    cover: "https://i.scdn.co/image/ab67616d00001e020e42d457a15ef2f133976f6b",
  },
};

export const firstPlaylistTrack = playlistTracks["spotify:track:68HocO7fx9z0MgDU0ZPHro"];
export const playlistTrackUris = Object.keys(playlistTracks);

export default playlistTracks;
